import { render, staticRenderFns } from "./ParticaArticleProof.vue?vue&type=template&id=6999c09a&scoped=true&"
import script from "./ParticaArticleProof.vue?vue&type=script&lang=ts&"
export * from "./ParticaArticleProof.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaArticleProof.vue?vue&type=style&index=0&id=6999c09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6999c09a",
  null
  
)

export default component.exports